import type { FieldValues, SubmitHandler } from "react-hook-form";

/**
 * Оборачивает submit handler: save выполняется только после успешного resolve handler.
 *
 * @param handler исходный submit callback
 * @param saveSubmittedValues save remembered values
 * @param enabled включена ли submission memory
 * @returns wrapped handler или исходный
 */
export function wrapFormSubmissionMemorySubmitHandler<TFieldValues extends FieldValues>(
    handler: SubmitHandler<TFieldValues> | undefined,
    saveSubmittedValues: (data: TFieldValues) => void,
    enabled: boolean,
): SubmitHandler<TFieldValues> | undefined {
    if (handler == null) {
        return undefined;
    }

    if (!enabled) {
        return handler;
    }

    return async (data: TFieldValues) => {
        await Promise.resolve(handler(data));
        saveSubmittedValues(data);
    };
}
